import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcDefault,
} from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  ...environmentDefaults,
  oidc: {
    ...oidcDefault,
    secureUris: ['https://p-chcp.digitaledge.cigna.com', '/prv/secure'],
  },
  redirect: {
    crossOrigin: {
      domain: 'https://provider.evernorth.com',
    },
    inbox:
      '/isam/sps/chcp-p-idp-proofpoint/saml20/logininitial?PartnerId=https://saml-entity-id.proofpoint.com/cigna_hosted-pe3',
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://static.cigna.com/',
      resourceContent: 'https://p-digital-static.digitaledge.cigna.com/',
      secureApi: 'https://p-chcp.digitaledge.cigna.com/chcp',
      publicApi: 'https://p-chcp.digitaledge.cigna.com/public/chcp',
      gsgPublicApi: 'https://p-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-gsg.digitaledge.cigna.com',
      graphql: 'https://p-chcp.digitaledge.cigna.com/chcp/apollo-graphql',
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  trustId: '5045161',
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhBehaviorStandalone: false,
    patientEnhPower: false,
    patientEnhDentalAmInNet: false,
    claimsMcNotification: false,
    messageCenterPreference: false,
    messageCenterPrefWAM: false,
    messageCenteDashboard: false,
    messageCenterFilters: false,
    precertManual: false,
    emailVerifyPopup: false,
    claim360SearchOffice: false,
    claim360GA: false,
    allowTempIdPassAddition: false,
    newForgotPasswordView: false,
    ifpEnhanced: false,
    pdufWebsiteAddress: false,
  },
};
